import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CACHE_TIMES } from '@/modules/shared/constants';
import { fetchGlobalSearch } from './api';
import type { GlobalSearchResponse, GroupedResults } from './types';

export const groupByDocumentType = (hits: GlobalSearchResponse): GroupedResults => {
  const grouped: GroupedResults = {};
  hits.forEach((hit) => {
    (grouped[hit.document_type] ??= []).push(hit);
  });
  return grouped;
};

export const useGlobalSearchQuery = (term: string) => {
  return useQuery({
    queryKey: ['global-search', term],
    queryFn: ({ signal }) => fetchGlobalSearch(term, signal),
    enabled: term.length > 0,
    staleTime: CACHE_TIMES.STALE_TIME,
    gcTime: CACHE_TIMES.GC_TIME,
    placeholderData: keepPreviousData,
    select: groupByDocumentType,
  });
};
